import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import './workspace.css';

// Rechargement automatique si un chunk JS est introuvable après un déploiement
window.addEventListener('vite:preloadError', () => {
  const key = 'vite_chunk_reload';
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, '1');
    window.location.reload();
  }
});
window.addEventListener('load', () => sessionStorage.removeItem('vite_chunk_reload'));

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { borderRadius: '8px', background: '#1A1710', color: '#FEF9EC' },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
);
